import getAbTestData from '@/common/abTest';

let addressAbCache = null;
export async function getAddressAb(): Promise<
    {
        experimentName?: string;
        groupName?: string;
        value?: boolean;
        key: string;
    }[]
> {
    const r =
        addressAbCache ||
        (await getAbTestData({
            address_editing_page_security_information: 'bool',
            address_filling_interaction_optimization: 'bool',
            if_krn_address: 'bool',
            if_krn_webpack: 'bool',
            field_display_on_hit_editing_page: 'bool',
        }));
    console.log('address ab:::', r);
    addressAbCache = r;
    const d = [
        {
            key: 'address_editing_page_security_information',
            ...(r?.address_editing_page_security_information ?? {}),
        },
        {
            key: 'address_filling_interaction_optimization',
            ...(r?.address_filling_interaction_optimization ?? {}),
        },
        { key: 'if_krn_address', ...(r?.if_krn_address ?? {}) },
        { key: 'if_krn_webpack', ...(r?.if_krn_webpack ?? {}) },
        { key: 'field_display_on_hit_editing_page', ...(r?.field_display_on_hit_editing_page ?? {}) },
    ];

    return d;
}
export function useAddressAb() {
    return {
        getAddressAb,
    };
}
